interface DezoomDotsProps {
  used: number;
  total?: number;
}

export function DezoomDots({ used, total = 5 }: DezoomDotsProps) {
  return (
    <div className="dezoom-dots" role="status" aria-label={`${used} dézooms sur ${total}`}>
      {Array.from({ length: total }, (_, i) => (
        <span key={i} className={i < used ? 'dot used' : 'dot'} aria-hidden />
      ))}
    </div>
  );
}
